import { customAxios } from '../../common/customAxios';
import { usersOwnTractorsApiUrl } from '../queries/getUsersOwnTractors';

interface postPokeToUserOwnTractorParams {
  tractorId: string;
  reqBody: {
    suggestedPrice: number | null;
  };
}

export const postPokeToUserOwnTractor = ({ tractorId, reqBody }: postPokeToUserOwnTractorParams): Promise<void> => {
  return customAxios.post(`${usersOwnTractorsApiUrl}/${tractorId}/pokes`, reqBody);
};
